<template>
  <div class="location">
    <div class="line" v-if="isMobile"></div>
    <template v-if="info.side_control && info.side_control.time_location === 1 && info.type === 1">
      <div class="title">
        {{info.location_title || '时间地点'}}
      </div>
      <div class="map-container" v-if="info.type === 1 && info.map_type === 1">
        <AMap :info="info" :width="isMobile ? '100%' : '302px'" :height="'170px'" :center="centerPoint"/>
      </div>
      <div class="detail">
        <p class="item time" v-if="info.side_control && info.side_control.time === 1 && info.start_time > 0">
          <img src="../../assets/img/form/time.png" alt="">
          <span>{{time}}</span>
        </p>
        <p class="item loca" v-if="info.side_control && info.side_control.location === 1 && address">
          <img src="../../assets/img/form/location.png" alt="">
          <span>{{address}}</span>
        </p>
      </div>
    </template>
    <template  v-if="info.side_control && info.side_control.contact === 1">
      <div class="title contact">
        {{info.contact_title || '联系我们'}}
      </div>
      <div class="detail">
        <p class="item" style="line-height: 30px">{{info.contact}}</p>
      </div>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import AMap from './AMap'

import moment from 'moment'
import 'moment/locale/zh-cn'
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  components: {
    AMap
  },
  computed: {
    ...mapState([
      'isMobile'
    ]),
    centerPoint () {
      return this.info.map_data
    },
    address () {
      return this.info.address
    },
    time () {
      let start = new Date(this.info.start_time * 1000)
      let end = new Date(this.info.end_time * 1000)
      if (+this.info.time_style === 2) {
        moment.locale('en')
        if (start.getDate() === end.getDate()) {
          return moment(start).format('MMM Do YYYY, HH:mm') + ' - ' + moment(end).format('HH:mm')
        } else if (start.getFullYear() === end.getFullYear()) {
          return moment(start).format('MMM Do YYYY, HH:mm') + ' - ' + moment(end).format('MMM Do HH:mm')
        } else {
          return moment(start).format('MMM Do YYYY, HH:mm') + ' - ' + moment(end).format('MMM Do YYYY HH:mm')
        }
      } else {
        if (start.getDate() === end.getDate()) {
          return moment(start).format('YYYY年MM月DD日 HH:mm') + ' - ' + moment(end).format('HH:mm')
        } else if (start.getFullYear() === end.getFullYear()) {
          return moment(start).format('YYYY年MM月DD日 HH:mm') + ' - ' + moment(end).format('MM月DD日 HH:mm')
        } else {
          return moment(start).format('YYYY年MM月DD日 HH:mm') + ' - ' + moment(end).format('YYYY年MM月DD日 HH:mm')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/css/_common";

.location {

  & .title {
    margin-top: 2px;
    margin-bottom: 13px;
    color: $lightBlack;
    @include lineFont(20, 600);

    &.contact {
      margin-bottom: 7px;
    }
  }

  & .map-container {
    margin-bottom: 16px;
    border-radius: 4px;
  }

  & .detail {
    margin-bottom: 37px;

    & .item {
      display: flex; align-items: center;
      margin-bottom: 7px;
      color: $lightBlack;
      line-height: 21px;
      @include font(14, 400);
      white-space: pre-wrap;

      & img {
        margin-right: 8px;
        height: 15px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .location {
    padding: 0 20px;
    
    & .line {
      width: 100vw; height: 8px;
      margin-left: -20px;
      margin-bottom: 32px;
      background: #F6F7F8;
    }

    & .title {
      &.contact {
        margin-bottom: 12px;
      }
    }

    & .detail:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
